import React, { useState } from 'react';
import { X, Calendar, Check, X as XIcon } from 'lucide-react';

const AddDayModal = ({ isOpen, onClose, onConfirm }) => {
  const [dayInput, setDayInput] = useState('');

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (dayInput.trim()) {
      onConfirm(dayInput.trim());
      setDayInput('');
      onClose();
    }
  };

  const handleCancel = () => {
    setDayInput('');
    onClose();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleConfirm();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content max-w-md relative" onClick={(e) => e.stopPropagation()}>
        {/* 关闭按钮 */}
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 p-2 rounded-full hover:bg-gray-100 z-10 flex items-center justify-center"
        >
          <X size={18} />
        </button>

        <div className="modal-header">
          <h3 className="text-lg font-semibold text-gray-900 flex items-center">
            <Calendar size={20} className="mr-2" />
            添加星期
          </h3>
        </div>

        <div className="modal-body">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              星期名称
            </label>
            <input
              type="text"
              value={dayInput}
              onChange={(e) => setDayInput(e.target.value)}
              onKeyDown={handleKeyPress}
              placeholder="例如：星期六"
              className="w-full p-3 border-2 border-gray-300 rounded-lg text-sm transition-colors duration-300 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-200"
            />
            <p className="text-xs text-gray-500 mt-1">
              请输入星期名称，如：星期六、星期日
            </p>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={handleConfirm}>
            <Check size={16} className="mr-2" />
            确认
          </button>
          <button className="btn btn-danger" onClick={handleCancel}>
            <XIcon size={16} className="mr-2" />
            取消
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddDayModal;
